export default function getResource(label) {
    const resources = {
        productPrice: 'Prix',
        fillSize: 'Taille de remplissage',
        rating: 'Cote',
        ingredientHighlights: 'Avantages des ingrédients',
        seeDetails: 'Voir tous les détails',
        value: 'valeur',
        goodFor: 'Idéal pour',
        targetedConcerns: 'Cible les préoccupations suivantes',
        skinValues: 'Peau',
        hairValues: 'Cheveux',
        highlyRated: 'Évalué très favorablement par les clients pour'
    };

    return resources[label];
}
